import { Component, Input } from '@angular/core';

import { Task } from 'app/models';
import { TaskService } from 'app/services';

@Component({
  selector: 'tasklog',
  templateUrl: './tasklog.component.html',
  styleUrls: ['./tasklog.component.scss']
})
export class TaskLogComponent {
  @Input() task: Task;

  constructor(private readonly taskService: TaskService) {}

  public refreshTask() {
    this.taskService.getTaskByType(this.task.type).subscribe(result => (this.task = result));
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/tasklog/tasklog.component.ts